/**
 * SiteSuspended — Shown when a tenant's site is gated (suspended/cancelled/trial expired)
 */
import React from "react";
import { AlertTriangle } from "lucide-react";

export default function SiteSuspended({ message }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white px-4"
      data-testid="site-suspended-page">
      <div className="max-w-md text-center">
        <div className="h-16 w-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">Site Unavailable</h1>
        <p className="text-base text-slate-500 leading-relaxed mb-6">
          {message || "This website is temporarily unavailable. Please check back later or contact the business owner."}
        </p>
        <div className="h-px w-24 bg-slate-200 mx-auto mb-4" />
        <p className="text-xs text-slate-400">Powered by PartyRentalSuite</p>
      </div>
    </div>
  );
}
